import { render, staticRenderFns } from "./TaskDiagram.vue?vue&type=template&id=00d1aa9f&"
import script from "./TaskDiagram.vue?vue&type=script&lang=js&"
export * from "./TaskDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports